/** Tone of an embed status line. */
export type EmbedMessageTone = 'muted' | 'error';

export interface EmbedMessageProps {
  /** The line to show. */
  readonly text: string;
  /** 'muted' for loading/empty (default), 'error' for a failure. */
  readonly tone?: EmbedMessageTone;
}

/**
 * A compact one-line status for the embed. The embed lives in a small Salesforce
 * panel, so loading/empty/error states must stay short — never a full-height
 * hero. This is deliberately smaller than the app's `LoadingState`/`ErrorNotice`.
 *
 * @param props - The text and tone.
 * @returns The status line.
 */
export function EmbedMessage({ text, tone = 'muted' }: EmbedMessageProps): React.ReactElement {
  return (
    <p
      className={`px-1 py-2 text-portal-small ${tone === 'error' ? 'text-rose-600' : 'text-portal-muted'}`}
    >
      {text}
    </p>
  );
}
